<template>
  <el-dialog
    :title="field(shopName) + '：产品管理'"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    fullscreen
  >
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction">
      <template v-slot:before>
        <el-form-item>
          <el-dropdown>
            <el-button type="info" size="small">
              {{ field(selectTypeName) }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, key) in searchTypeList"
                :key="key"
                @click.native="clickType(item.Id, item.Name)"
                >{{ field(item.Name) }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </template>
      <template v-slot:default>
        <el-button
          type="success"
          size="small"
          @click.native="openProductType()"
          :loading="typeLoading"
          >{{ $t("Product.Type") }}</el-button
        >
      </template>
    </toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
    >
      <el-table-column type="selection" width="30"></el-table-column>
      <el-table-column
        :label="$t('Sort')"
        prop="Sort"
        width="50"
      ></el-table-column>
      <el-table-column :label="$t('Cover')" width="120">
        <template slot-scope="scope">
          <div
            v-if="scope.row.Cover != null && scope.row.Cover != ''"
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')" width="200">
        <template slot-scope="scope">{{ field(scope.row.Name) }}</template>
      </el-table-column>
      <el-table-column :label="$t('TypeName')" width="150">
        <template slot-scope="scope">{{
          field(scope.row.ProductType.Name)
        }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('LowestNumber')"
        width="80"
        prop="LowestNumber"
      ></el-table-column>
      <el-table-column
        :label="$t('MaxNumber')"
        width="80"
        prop="MaxNumber"
      ></el-table-column>
      <el-table-column :label="$t('Price')" width="100" prop="Price">
        <template slot-scope="scope">
          <span class="text_red">$ {{ scope.row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Reco" :label="$t('Reco')" width="70">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Reco ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Reco ? $t("yes") : $t("no") }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Hot" :label="$t('Hot')" width="70">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Hot ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Hot ? $t("yes") : $t("no") }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="80">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? $t("enabled") : $t("disable") }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('Spec')" width="550">
        <template slot-scope="scope">
          <el-table
            :data="scope.row.SpecTypeList"
            style="width: 100%"
            size="mini"
            border
          >
            <el-table-column type="expand" width="80">
              <template slot="header">
                <el-button
                  type="success"
                  size="mini"
                  @click="addSpecType(scope.row.Id)"
                  >{{ $t("add") }}</el-button
                >
              </template>
              <template slot-scope="props">
                <el-row
                  :gutter="20"
                  v-for="item in props.row.ProductSpecList"
                  :key="item.Id"
                >
                  <el-col :span="4">{{ item.Sort }}</el-col>
                  <el-col :span="10">{{ field(item.Name) }}</el-col>
                  <el-col :span="7" class="text_red">$ {{ item.Price }}</el-col>
                  <el-col :span="3">
                    <i
                      :class="
                        item.Enabled
                          ? 'text_green el-icon-circle-check'
                          : 'text_red el-icon-circle-close'
                      "
                    ></i>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('Sort')"
              prop="Sort"
              width="50"
            ></el-table-column>
            <el-table-column :label="$t('Name')">
              <template slot-scope="scope">{{
                field(scope.row.Name)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('Product.ItemQTY')" width="90">
              <template slot-scope="scope">{{
                scope.row.ItemQTY == 0 ? "不限" : scope.row.ItemQTY
              }}</template>
            </el-table-column>
            <el-table-column prop="Enabled" :label="$t('Enabled')" width="90">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Enabled ? 'success' : 'danger'"
                  disable-transitions
                  >{{
                    scope.row.Enabled ? $t("enabled") : $t("disable")
                  }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column :label="$t('operation')" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="editSpecType(scope.row)"
                  icon="el-icon-edit"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deleteSpecType(scope.row.Id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button
        type="primary"
        size="mini"
        style="margin-top: 5px"
        @click="openEnabled"
        :disabled="this.list.length === 0"
        >批量启用</el-button
      >
      <el-button
        type="primary"
        size="mini"
        style="margin-top: 5px"
        @click="openAddAllSpec"
        :disabled="this.list.length === 0"
        >批量添加规格</el-button
      >
      <el-button
        type="primary"
        size="mini"
        style="margin-top: 5px"
        @click="openMove"
        :disabled="this.list.length === 0"
        >批量移动</el-button
      >
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Sort')" prop="Sort">
              <el-input
                v-model.number="editForm.Sort"
                type="text"
                maxlength="3"
                style="width: 100px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('uploadImgLabel')">
              <UploadShopFiles
                :accept="'.png,.gif,.jpg,.jpeg'"
                ref="editupload"
                :Cover="editForm.Cover"
                @Cover="
                  (Cover) => {
                    editForm.Cover = Cover;
                  }
                "
                :BaseUrl="baseCoverUrl"
                :TableId="1"
                v-model="editForm.Id"
                :listType="'picture'"
              ></UploadShopFiles>
            </el-form-item>
            <el-form-item
              :label="$t('TypeName')"
              prop="Type"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('TypeName'),
              }"
            >
              <el-select v-model="editForm.Type" placeholder="Select Type">
                <el-option
                  v-for="item in typeList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="原价"
              prop="OriginalPrice"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '原价',
              }"
            >
              <el-input-number
                v-model.number="editForm.OriginalPrice"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('Price')"
              prop="Price"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Price'),
              }"
            >
              <el-input-number
                v-model.number="editForm.Price"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('LowestNumber')"
              prop="LowestNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('LowestNumber'),
              }"
            >
              <el-input
                v-model.number="editForm.LowestNumber"
                type="text"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('MaxNumber')"
              prop="MaxNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('MaxNumber'),
              }"
            >
              <el-input
                v-model.number="editForm.MaxNumber"
                type="text"
                style="width: 195px"
              >
                <template slot="suffix">0为不限</template>
              </el-input>
            </el-form-item>
            <el-form-item label="销售截止日期" prop="EndDate">
              <el-date-picker
                v-model="editForm.EndDate"
                type="date"
                placeholder="Select EndDate"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="派送开始时间" prop="DeliveryStartDate">
              <el-date-picker
                :picker-options="pickerOptionsEditStart"
                v-model="editForm.DeliveryStartDate"
                type="date"
                placeholder="Select Date"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="派送结束时间" prop="DeliveryEndDate">
              <el-date-picker
                :picker-options="pickerOptionsEditEnd"
                v-model="editForm.DeliveryEndDate"
                type="date"
                placeholder="Select Date"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('Reco')">
              <el-switch v-model="editForm.Reco"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Hot')">
              <el-switch v-model="editForm.Hot"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Introduce')">
              <el-input
                type="textarea"
                :rows="3"
                v-model="editForm.Introduce[slot.langkey]"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Introduce')">
              <el-input
                type="textarea"
                :rows="3"
                v-model="editForm.Introduce[slot.item.key]"
              ></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Sort')" prop="Sort">
              <el-input
                v-model.number="addForm.Sort"
                type="text"
                maxlength="3"
                style="width: 100px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('uploadImgLabel')">
              <UploadShopFiles
                :accept="'.png,.gif,.jpg,.jpeg'"
                ref="addupload"
                :listType="'picture'"
              ></UploadShopFiles>
            </el-form-item>
            <el-form-item
              :label="$t('TypeName')"
              prop="Type"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('TypeName'),
              }"
            >
              <el-select v-model="addForm.Type" placeholder="Select Type">
                <el-option
                  v-for="item in typeList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="原价"
              prop="OriginalPrice"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '原价',
              }"
            >
              <el-input-number
                v-model.number="addForm.OriginalPrice"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('Price')"
              prop="Price"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Price'),
              }"
            >
              <el-input-number
                v-model.number="addForm.Price"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('LowestNumber')"
              prop="LowestNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('LowestNumber'),
              }"
            >
              <el-input
                v-model.number="addForm.LowestNumber"
                type="text"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('MaxNumber')"
              prop="MaxNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('MaxNumber'),
              }"
            >
              <el-input
                v-model.number="addForm.MaxNumber"
                type="text"
                style="width: 195px"
              >
                <template slot="suffix">0为不限</template>
              </el-input>
            </el-form-item>
            <el-form-item label="销售截止日期" prop="EndDate">
              <el-date-picker
                v-model="addForm.EndDate"
                type="date"
                placeholder="Select EndDate"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="派送开始时间" prop="DeliveryStartDate">
              <el-date-picker
                :picker-options="pickerOptionsAddStart"
                v-model="addForm.DeliveryStartDate"
                type="date"
                placeholder="Select Date"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="派送结束时间" prop="DeliveryEndDate">
              <el-date-picker
                :picker-options="pickerOptionsAddEnd"
                v-model="addForm.DeliveryEndDate"
                type="date"
                placeholder="Select Date"
                :editable="false"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('Reco')">
              <el-switch v-model="addForm.Reco"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Hot')">
              <el-switch v-model="addForm.Hot"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Introduce')">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addForm.Introduce[slot.langkey]"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Introduce')">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addForm.Introduce[slot.item.key]"
              ></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!--上传数据-->
    <el-dialog
      :title="$t('HistoryFolder.UploadData')"
      :visible.sync="uploadFormVisible"
      v-model="uploadFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="uploadForm"
        label-width="150px"
        ref="uploadForm"
        size="small"
      >
        <el-form-item :label="$t('HistoryFolder.UploadData')">
          <el-upload
            ref="uploadFile"
            class="upload-img-list"
            :auto-upload="false"
            action="xxx"
            :limit="1"
            accept=".xlsx"
          >
            <el-button size="small" type="primary">{{
              $t("uploadClick")
            }}</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ $t("uploadtipStart") + ".xlsx" }}
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('uploadImgLabel')">
          <el-upload
            ref="uploadImgFile"
            class="upload-img-list"
            :auto-upload="false"
            multiple
            action="xxx"
            :limit="200"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG"
          >
            <el-button size="small" type="primary">{{
              $t("uploadClick")
            }}</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ $t("uploadtipStart") + ".jpg,.jpeg,.png,.JPG,.JPEG" }}
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="uploadFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="uploadSubmit"
          :loading="uploadLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <!--批量转移-->
    <el-dialog
      title="批量转移"
      :visible.sync="openMoveVisible"
      v-model="openMoveVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="moveForm"
        label-width="150px"
        ref="moveForm"
        size="small"
      >
        <el-form-item label="项目数量">
          {{ moveForm.ProductList.length }}
        </el-form-item>
        <el-form-item
          label="商户"
          prop="Shop_Id"
          :rules="{ required: true, message: $t('pleaseEnter') + '商户' }"
        >
          <el-select
            v-model="moveForm.Shop_Id"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="shopRemoteMethod"
            :loading="selectShoploading"
            @change="shopMoveChange"
            style="width: 300px"
          >
            <el-option
              v-for="item in shopList"
              :key="item.Id"
              :label="field(item.Name)"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分类"
          prop="Type"
          :rules="{ required: true, message: $t('pleaseEnter') + '分类' }"
        >
          <el-select
            v-model="moveForm.Type"
            clearable
            placeholder="请输选择分类"
            :loading="selectProTypeloading"
          >
            <el-option
              v-for="item in targetTypeList"
              :key="item.Id"
              :label="field(item.Name)"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="openMoveVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="moveSubmit"
          :loading="moveLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <!--类型管理-->
    <ProductType ref="productTypeDialog"></ProductType>
    <ProductSpec ref="productSpecDialog"></ProductSpec>
  </el-dialog>
</template>

<script>
import UploadShopFiles from "@/components/UploadShopFiles";
import ProductType from "./ProductType";
import ProductSpec from "./ProductSpec";
import util from "util/date";
import {
  base,
  getProductBasis,
  getProductListPage,
  removeProduct,
  editProduct,
  addProduct,
  openProductEnabled,
  removeProductSpecType,
  importProductdata,
  getShopList,
  getProductTypeListPage,
  updateProductTarget,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  components: {
    UploadShopFiles,
    ProductType,
    ProductSpec,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      typeList: [],
      dataSelection: [],
      dialogVisible: false,
      shopName: "",
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {
        Name: {},
      },
      baseCoverUrl: base + "/FileUpload/Product/b0/",
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: { Name: {}, Detailed: {} },
      typeLoading: false,
      searchTypeList: [
        {
          Name: {
            zh_cn: "全部分类",
            en_us: "All Type",
          },
          Id: 0,
        },
      ],
      selectType: 0,
      selectTypeName: {
        zh_cn: "全部分类",
        en_us: "All Type",
      },
      shopId: 0,
      uploadFormVisible: false,
      uploadForm: {},
      uploadLoading: false,
      openMoveVisible: false,
      moveLoading: false,
      moveForm: {
        ProductList: [],
      },
      selectShoploading: false,
      shopList: [],
      targetTypeList: [],
      selectProTypeloading: false,
      pickerOptionsAddStart: {
        disabledDate: (time) => {
          const endDateVal = new Date(this.addForm.DeliveryEndDate).getTime();
          if (endDateVal) {
            return time.getTime() > endDateVal - 0;
          }
        },
      },
      pickerOptionsAddEnd: {
        disabledDate: (time) => {
          var newdate = new Date(this.addForm.DeliveryStartDate);
          const beginDateVal = new Date(
            newdate.setDate(newdate.getDate())
          ).getTime();
          if (beginDateVal) {
            return time.getTime() < beginDateVal - 0;
          }
        },
      },
      pickerOptionsEditStart: {
        disabledDate: (time) => {
          const endDateVal = new Date(this.editForm.DeliveryEndDate).getTime();
          if (endDateVal) {
            return time.getTime() > endDateVal - 0;
          }
        },
      },
      pickerOptionsEditEnd: {
        disabledDate: (time) => {
          var newdate = new Date(this.editForm.DeliveryStartDate);
          const beginDateVal = new Date(
            newdate.setDate(newdate.getDate())
          ).getTime();
          if (beginDateVal) {
            return time.getTime() < beginDateVal - 0;
          }
        },
      },
    };
  },
  provide() {
    return {
      getProductBasis: this.getProductBasis,
      getProductList: this.getList,
    };
  },
  methods: {
    shopRemoteMethod(query) {
      if (query !== "") {
        let para = {
          key: query,
        };
        this.selectShoploading = true;
        getShopList(para).then((res) => {
          this.shopList = res.data.response.data;
          this.selectShoploading = false;
        });
      } else {
        targetTypeList;
        this.shopList = [];
      }
    },
    shopMoveChange(e) {
      let para = {
        shopId: e,
      };
      this.selectProTypeloading = true;
      getProductTypeListPage(para).then((res) => {
        this.targetTypeList = res.data.response;
        this.selectProTypeloading = false;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    openMove(val) {
      if (this.dataSelection.length <= 0) {
        this.$message({
          message: this.$t("ZeroChoose"),
          type: "error",
        });
        return;
      }
      this.openMoveVisible = true;
      this.moveForm = {
        ProductList: this.dataSelection,
      };
    },
    moveSubmit() {
      if (this.moveForm.ProductList.length <= 0) {
        this.$message({
          message: this.$t("ZeroChoose"),
          type: "error",
        });
        return;
      }
      this.$confirm("确定移动吗？", this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.moveLoading = true;
          updateProductTarget(this.moveForm).then((res) => {
            if (util.isEmt.format(res)) {
              this.moveLoading = false;
              return;
            }
              if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.openMoveVisible = false;
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.dataSelection = val;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    openProductType() {
      this.$refs.productTypeDialog.loadData(this.shopId);
    },
    addSpecType(id) {
      this.$refs.productSpecDialog.handleAdd(id);
    },
    editSpecType(row) {
      this.$refs.productSpecDialog.handleEdit(row);
    },
    importData() {
      if (this.$refs.uploadFile != null) {
        this.$refs.uploadFile.clearFiles();
      }
      this.uploadFormVisible = true;
      this.uploadForm = {
        shopId: this.shopId,
      };
    },
    uploadSubmit() {
      let _this = this;
      if (this.$refs.uploadFile.uploadFiles.length <= 0) {
        this.$message({
          message: this.$t("pleaseUpload"),
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
        .then(() => {
          this.uploadLoading = true;
          let para = Object.assign({}, this.uploadForm);
          importProductdata(
            para,
            this.$refs.uploadFile.uploadFiles,
            this.$refs.uploadImgFile.uploadFiles
          ).then((res) => {
            this.uploadLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["uploadForm"].resetFields();
              this.uploadFormVisible = false;
              this.$refs.uploadFile.clearFiles();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    openEnabled() {
      if (this.dataSelection.length <= 0) {
        this.$message({
          message: this.$t("ZeroChoose"),
          type: "error",
        });
        return;
      }
      this.$confirm("确定启用吗？", this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { ProductList: this.dataSelection };
          openProductEnabled(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    openAddAllSpec() {
      if (this.dataSelection.length <= 0) {
        this.$message({
          message: this.$t("ZeroChoose"),
          type: "error",
        });
        return;
      }
      this.$refs.productSpecDialog.handleAllAdd(this.dataSelection);
    },
    deleteSpecType(id) {
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: id };
          removeProductSpecType(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    clickType(val, name) {
      this.selectType = val;
      this.selectTypeName = name;
      this.getList();
    },
    getProductBasis() {
      getProductBasis({ shopId: this.shopId }).then((res) => {
        this.searchTypeList = [
          {
            Name: {
              zh_cn: "全部分类",
              en_us: "All Type",
            },
            Id: 0,
          },
        ];
        this.searchTypeList = this.searchTypeList.concat(
          res.data.response.typeList
        );
        this.typeList = res.data.response.typeList;
      });
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      let para = {
        key: this.filters.Name,
        page: this.page,
        type: this.selectType,
        shopId: this.shopId,
      };
      this.listLoading = true;
      getProductListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeProduct(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑活动界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //编辑活动
    editSubmit: function () {
      let _this = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          _this.editForm.fileData = _this.$refs.editupload.FilesBase64();
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editProduct(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.$refs.editupload.clearFiles();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //显示新增活动界面
    handleAdd() {
      if (this.$refs.addupload != null) {
        this.$refs.addupload.clearFiles();
      }
      if (this.typeList.length <= 0) {
        this.$message({
          message: "请添加类型",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        Sort: 0,
        Name: {},
        fileData: [],
        OriginalPrice: 0.0,
        Price: 0.0,
        LowestNumber: 1,
        EndDate: "",
        DeliveryStartDate: "",
        DeliveryEndDate: "",
        Introduce: {},
        ThemeId: 0,
        MaxNumber: 0,
        Reco: false,
        Hot: false,
        Shop_Id: this.shopId,
        Enabled: true,
        Detailed: {},
      };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          _this.addForm.fileData = _this.$refs.addupload.FilesBase64();
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addProduct(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    loadData(sname, sid) {
      this.shopName = sname;
      this.shopId = sid;
      this.page = 1;
      getProductBasis({ shopId: sid }).then((res) => {
        this.searchTypeList = this.searchTypeList.concat(
          res.data.response.typeList
        );
        this.typeList = res.data.response.typeList;
        this.getList();
      });
      this.dialogVisible = true;
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList("/ShopConfig/Product", routers);
    },
  },
};
</script>
